export const shoeSizes: string[] = [
    "лични",
    "25",
    "25-6",
    "26",
    "26-7",
    "27",
    "27-8",
    "28",
    "28-9",
    "29",
    "29-3",
    "30",
    "30-1",
    "31",
    "31-2",
    "32",
    "32-3",
    "33",
    "33-4",
    "34",
    "34-5",
    "35",
    "35-6",
    "36",
    "36-7",
    "37",
    "37-8",
    "38",
    "38-9",
    "39",
    "39-4",
    "40",
    "40-1",
    "41",
    "41-2",
    "42",
    "42-3",
    "43",
    "43-4",
    "44",
    "44-5",
    "45",
    "45-6",
    "46",
    "46-7",
    "47"
];